import { NavLink } from "react-router-dom";
import { Button as MButton, IconButton, Dialog, DialogTitle } from "@mui/material";
import { FaMoon } from "react-icons/fa";
import themeState from "states/themeEventTarget";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { OrgsDialog } from "components/OrgsDialog/OrgsDialog";
import { getOrg } from "redux/selectors/getOrg";
import membersService from "services/admin/membersService";
import usersService from "services/usersService";
import { ADMIN_HOME_PATH } from "helpers/url";

export default function UserMenu({ user }) {
  const [orgSwitcherVisible, setOrgSwitcherVisible] = useState(false)
  const [station, setStation] = useState(null)
  const currentMember = useSelector(getOrg);
  const token = useSelector((state) => state.auth.token);

  console.log("Current member in UserMenu:", currentMember);

  const publicMenu = [];
  let menu = [];

  // Роль сотрудника в текущей организации (fallback — глобальная роль пользователя)
  const roleName = currentMember?.role?.name || user?.roles?.[0]?.name;

  // Станции оператора (есть только у операторов приёмки/выдачи)
  // Запрос отменяется при logout/смене сотрудника, чтобы не уйти без токена
  useEffect(() => {
    if (!currentMember?.id || !token) {
      setStation(null);
      return;
    }
    const controller = new AbortController();
    membersService
      .getStation(currentMember.id, { signal: controller.signal })
      .then((res) => setStation(res?.data?.data || null))
      .catch(() => !controller.signal.aborted && setStation(null));
    return () => controller.abort();
  }, [currentMember?.id, token]);

  const stationNames = station ? station.name : "";

  if (user) {
    const profileMenuItem = {
      path: "/admin/profile",
      label: "Профиль",
      component: MButton,
    }

    if (window.location.pathname !== "/auth/select-org") {
      menu.push(profileMenuItem)
    }
    if (user.superadmin) {
      menu.push({
        path: "/superadmin/organizations",
        label: "Superadmin",
        component: MButton,
      },)
    }
    if (user.members.length > 0) {
      menu.push({
        onClick: () => {
          setOrgSwitcherVisible(true)
        },
        label: "Организации",
        component: MButton,
      },)
    }
  } else {
    menu = [
      ...publicMenu,
      {
        path: "/auth/login",
        label: "Войти",
        component: MButton,
      },
    ];
  }

  function toggleDarkMode() {
    themeState.toggle();
  }

  async function switchOrg(org) {
    localStorage.setItem('orgID', org.id)
    setOrgSwitcherVisible(false)
    try {
      // Запоминаем выбор на сервере
      await usersService.updateLastOrg(org.id)
    } catch (ex) {
      console.error("updateLastOrg ex: ", ex)
    }
    window.location.href = ADMIN_HOME_PATH
  }

  return (
    <>
      <div className={"user-menu sm:block xs:hidden mr-2 text-right flex flex-center"}>
        {user && (user.name || user.email) && (
          <div className="no-mobile" style={{ lineHeight: 1.25, marginRight: 8 }}>
            <div style={{ fontWeight: 600 }}>{currentMember?.name || user.email}</div>
            {(roleName || stationNames) && (
              <div style={{ fontSize: 12, opacity: 0.7 }}>
                {[roleName, stationNames].filter(Boolean).join(" · ")}
              </div>
            )}
          </div>
        )}
        {menu.map((item, menuIndex) => (
          <NavLink to={item.path || '#'} key={menuIndex} onClick={item.onClick}>
            <item.component>
              <i className="fad fa-brain fa-swap-opacity" style={{ marginRight: 10 }}></i>
              {item.label}
            </item.component>
          </NavLink>
        ))}
        <IconButton size="small" onClick={toggleDarkMode}>
          <FaMoon></FaMoon>
        </IconButton>
        {user ? <Dialog onClose={() => { setOrgSwitcherVisible(false) }} open={orgSwitcherVisible}>
          <DialogTitle>Выберите организацию</DialogTitle>
          <OrgsDialog switchOrg={switchOrg}></OrgsDialog>
        </Dialog> : <></>}
      </div>
    </>
  );
}